import { AxiosResponse } from 'axios'
import { useMutation } from 'react-query'

import { APIError } from '../../../../utils'
import { SendAsEmailModalVariant } from '../../enums/sendAsEmailModalVariant'
import {
  SendAsEmailResponse,
  sendInvoiceAsEmail,
  SendInvoiceAsEmailOptions,
  sendPaymentReminder,
} from '../../query-api'

type SendAsEmailMutation = (options: SendInvoiceAsEmailOptions) => Promise<AxiosResponse<SendAsEmailResponse>>

const sendAsEmailMutation: Record<SendAsEmailModalVariant, SendAsEmailMutation> = {
  [SendAsEmailModalVariant.Invoice]: sendInvoiceAsEmail,
  [SendAsEmailModalVariant.Reminder]: sendPaymentReminder,
}

interface UseSendAsEmailMutationProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
  variant: SendAsEmailModalVariant
}

export const useSendAsEmailMutation = ({ variant, ...props }: UseSendAsEmailMutationProps) => {
  const { onError, onSuccess } = props || {}
  const { mutate: send, isLoading, ...rest } = useMutation(sendAsEmailMutation[variant], { onSuccess, onError })

  return { send, isProcessing: isLoading, ...rest }
}
